'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactHookForm_useManagedProps = require('./useManagedProps.js');
var components_textInput_TextInput = require('../components/textInput/TextInput.js');
require('react-hook-form');
require('../hooks/useCombinedRefs.js');
require('./FormManagerProvider.js');
require('../_chunks/getSchemaPathRequirementMap-DIM0tidl.js');
require('lodash/isString');
require('@templafy/translation');
require('../hooks/useUUID.js');
require('../_chunks/FieldContext-DI94tJqT.js');
require('../components/form/FormContext.js');
require('../_chunks/BaseTextInput-CHJ9_GE-.js');
require('../_chunks/combineClasses-5P8GTQkg.js');
require('../_chunks/useInputAccessibilityProps-uzRyF5PP.js');
require('../utilities/createComponentNamespace.js');
require('../utilities/a11yIgnore.js');
require('../_chunks/BaseButton-DDcpn9-P.js');
require('../_chunks/useDevelopmentEffect-DGG0KnB_.js');
require('../icons/IconLoading.js');
require('../icons/Icon.js');
require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');
require('../components/visuallyHidden/VisuallyHidden.js');

// eslint-disable-next-line react/display-name
const ManagedTextInput = react.forwardRef((props, ref) => {
    const { propsWithRef } = reactHookForm_useManagedProps.useManagedProps(props, ref);
    return jsxRuntime.jsx(components_textInput_TextInput.TextInput, { ...propsWithRef });
});
ManagedTextInput.displayName = 'ManagedTextInput';

exports.ManagedTextInput = ManagedTextInput;
//# sourceMappingURL=ManagedTextInput.js.map
